import React, { useEffect, useState } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Edit, Trash2, Plus } from 'lucide-react';
import { toast } from 'react-toastify';
import { Facilities } from '../../util/Facilities';
import { useAppContext } from '../../context/AppContext';
import MotionModal from '../../components/MotionModal';
import Donotmail from './Donotmail';
import PermitForm from '../Permits/NewPermit';
import MailOwner from '../Permits/MailOwner';
import MailProvider from '../Permits/MailProvider';
import Products from '../Products/Products';
import api from '../../components/Api';
import {normalizedFacilities} from '../../util/Normalizedfacilities'
import SeedListForm from './Seed';
const Permits = () => {
  const { authState } = useAppContext();

  const [permits, setPermits] = useState([]);
  const [owners, setOwners] = useState([]);
  const [mailProviders, setMailProviders] = useState([]);
  const [products, setProducts] = useState([]);
  const [reset, setReset] = useState(false);

  const [activeModal, setActiveModal] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
 const [seedLists, setSeedLists] = useState([]);
  const [suppressionList, setSuppressionLists] = useState([]);

  /* ================= HELPERS ================= */

  const HeaderButton = ({ label, onClick }) => (
    <button onClick={onClick} className="btn-primary mb-4 flex items-center gap-2">
      <Plus size={16} /> {label}
    </button>
  );

  const TableWrapper = ({ children }) => (
    <div className="hidden md:block">
      <div className="relative overflow-x-auto bg-white border rounded-lg">
        <table className="w-full text-sm table-fixed">{children}</table>
      </div>
    </div>
  );

  const Th = ({ children }) => (
    <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase">
      {children}
    </th>
  );

  const Td = ({ children, className = '' }) => (
    <td className={`px-4 py-3 ${className}`}>{children}</td>
  );

  const RowActions = ({ onEdit, onDelete }) => (
    <div className="flex justify-end gap-3 shrink-0">
      <Edit
        size={16}
        className="cursor-pointer text-gray-500 hover:text-indigo-600"
        onClick={onEdit}
      />
      <Trash2
        size={16}
        className="cursor-pointer text-red-500"
        onClick={onDelete}
      />
    </div>
  );

  const MobileCards = ({ children }) => (
    <div className="md:hidden space-y-3">{children}</div>
  );

  const Card = ({ title, subtitle, extraInfo, onEdit, onDelete }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-white border rounded-lg p-4 w-full overflow-hidden">
      <div className="flex justify-between items-start">
        <div className="min-w-0 pr-2">
          <p className="font-medium text-gray-900 truncate">{title}</p>
          <p className=" text-gray-500 truncate">{subtitle}</p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-xs text-blue-500 hover:underline"
          >
            {expanded ? 'Hide Details' : 'Show Details'}
          </button>

          <RowActions onEdit={onEdit} onDelete={onDelete} />
        </div>
      </div>

      {expanded && extraInfo && (
        <div className="mt-2 text-xs text-gray-700">
          {extraInfo}
        </div>
      )}
    </div>
  );
};
  // const Card = ({ title, subtitle, onEdit, onDelete }) => (
  //   <div className="bg-white border rounded-lg p-4 flex justify-between items-start w-full overflow-hidden">
  //     <div className="min-w-0 pr-2">
  //       <p className="font-medium text-sm text-gray-900 truncate">
  //         {title}
  //       </p>
  //       <p className="text-xs text-gray-500 truncate">
  //         {subtitle}
  //       </p>
  //     </div>
  //     <RowActions onEdit={onEdit} onDelete={onDelete} />
  //   </div>
  // );

  /* ================= DATA LOAD ================= */

  useEffect(() => {
    if (!authState?.user?.company) return;

    const loadData = async () => {
const [p, o, m, prod, seeds,suppress] = await Promise.all([
  api.post('/permits/getpermitholder', { id: authState.user.company }),
  api.post('/permits/getmailowners', { id: authState.user.company }),
  api.post('/permits/getmailproviders', { id: authState.user.company }),
  api.post('/products/getproducts', { id: authState.user.company }),
  api.post('/permits/seeds/all', { id: authState.user.company }),
  api.post('/permits/suppress/all', { id: authState.user.company })

]);

setPermits(p.data);
setOwners(o.data);
setMailProviders(m.data);
setProducts(prod.data.products || []);
setSeedLists(seeds.data);
setSuppressionLists(suppress.data);
    };

    loadData();
  }, [reset,authState]);

  const openModal = (type, item = null) => {
    setSelectedItem(item);
    setActiveModal(type);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setActiveModal(null);
  };

  const requestDelete = (type, item) => {
    setConfirmDelete({ type, item });
  };


  const confirmDeleteAction = async () => {
  const { type, item } = confirmDelete;

  const deleteConfigs = {
    permit:    { base: '/permits', action: 'removepermit' },
    owner:     { base: '/permits', action: 'removeowner' },
    provider:  { base: '/permits', action: 'removeprovider' },
    product:   { base: '/products', action: 'remove' },  
    seed: { base: '/permits', action: `seeds/${item._id}` },
     suppress: { base: '/permits', action: `suppress/${item._id}` },
  };

  const config = deleteConfigs[type];

  if (!config) {
    toast.error('Invalid delete type');
    return;
  }

  try {
    const url = config.action
      ? `${config.base}/${config.action}`
      : `${config.base}/${item._id}`;   // for direct DELETE /products/:id

      const isDeleteMethod = type === 'seed' || type === 'suppress'
console.log(isDeleteMethod)
await (isDeleteMethod
  ? api.delete(url, { data: { id: item._id } })
  : api.post(url, { id: item._id })
);

    

    toast.success('Deleted successfully');
    setReset(p => !p);
    setConfirmDelete(null);
  } catch (err) {
    console.error('Delete failed:', err);
    toast.error('Delete failed');
  }
};
  // const confirmDeleteAction = async () => {
  //   const { type, item } = confirmDelete;

  //   const endpoints = {
  //     permit: 'removepermit',
  //     owner: 'removeowner',
  //     provider: 'removeprovider',
  //     product: 'removeproduct',
  //   };

  //   try {
  //     await api.post(`/permits/${endpoints[type]}`, { id: item._id });
  //     toast.success('Deleted');
  //     setReset(p => !p);
  //     setConfirmDelete(null);
  //   } catch {
  //     toast.error('Delete failed');
  //   }
  // };

const getDeleteText = () => {
  if (!confirmDelete?.item) return '';

  const { type, item } = confirmDelete;

  switch (type) {
    case 'permit':
      return `Are you sure you want to delete permit
#${item.permitNumber} - ${item.permitName}`;

    case 'provider':
      return `Are you sure you want to delete provider
${item.name} (CRID: ${item.crid})`;

    case 'owner':
      return `Are you sure you want to delete owner
${item.companyName} (CRID: ${item.crid})`;

    case 'product':
      return `Are you sure you want to delete product
${item.name} ${item.sku ? `(SKU: ${item.sku})` : ''}`;

    default:
      return 'Are you sure you want to delete this item?';
  }
};
  console.log(confirmDelete)
  /* ================= RENDER ================= */

  return (
    <div className="max-w-6xl mx-auto px-4 py-6 overflow-x-hidden relative">
      <h1 className="text-xl font-semibold mb-6">
        Permits & Products Configuration
      </h1>

      <Tabs>
        {/* <TabList className="flex gap-2 mb-6 overflow-x-auto text-sm whitespace-nowrap"> */}
        <TabList
  className="
    flex
    flex-wrap
    gap-2
    mb-6
    text-sm
    max-w-full
  "
  style={{borderBottom:'1px solid gray'}}
>
          <Tab>Permit Holders</Tab>
          <Tab>Mail Providers</Tab>
          <Tab>Mail Owners</Tab>
          <Tab>Products</Tab>
             <Tab>Do Not Mail (Suppression) Lists</Tab>
                <Tab>Seed Lists</Tab>
        </TabList>

        {/* ===== PERMITS ===== */}
        <TabPanel>
          <HeaderButton label="New Permit" onClick={() => openModal('permit')} />

          <TableWrapper>
            <thead>
              <tr>
                <Th>Name</Th>
                <Th>Permit #</Th>
                <Th>Company</Th>
                <Th>Address </Th>
                <Th>Permit Post Office</Th>
                <Th />
              </tr>
            </thead>
            <tbody style={{fontSize:'.9rem'}}>
              {permits?.map(p => (
                <tr key={p._id} className="border-t">
                  <Td>{p.permitName}</Td>
                  <Td>{p.permitNumber}</Td>
              
                   <Td>{p.companyName}</Td>
                    <Td colSpan={2} >{p.address} {p.address2}<br /> {p.city} {p.state}, {p.zip}</Td>
                     <Td colSpan={2}>{p.bmeuFacility?.dropdelcty} {p.bmeuFacility?.dropdelst}, {p.bmeuFacility?.dropdelzpp}</Td>
                         <Td className="text-right">
                    <RowActions
                      onEdit={() => openModal('permit', p)}
                      onDelete={() => requestDelete('permit', p)}
                    />
                  </Td>
                </tr>
              ))}
            </tbody>
          </TableWrapper>

          <MobileCards>
            {permits?.map(p => (
              <Card
                key={p._id}
                title={p.permitName}
                subtitle={`Permit #: ${p.permitNumber}`}
                onEdit={() => openModal('permit', p)}
                onDelete={() => requestDelete('permit', p)}
                  extraInfo={(
        <>
          <p>Company: {p.companyName}</p>
          <p>Address: {p.address}<br />{p.city} {p.state}, {p.zip}</p>
          <p>Permit P.O.:{p.bmeuFacility?.dropname} <br />
          {p.address}<br />{p.bmeuFacility?.dropdelcty} {p.bmeuFacility?.dropdelst}, {p.bmeuFacility?.dropdelzpp}</p>
        </>
      )}
              />
            ))}
          </MobileCards>
        </TabPanel>

        {/* ===== PROVIDERS ===== */}
        <TabPanel>
          <HeaderButton label="New Provider" onClick={() => openModal('provider')} />

          <TableWrapper>
            <thead>
              <tr>
                <Th>Name</Th>
                <Th>CRID</Th>
                <Th />
              </tr>
            </thead>
            <tbody>
              {mailProviders?.map(p => (
                <tr key={p._id} className="border-t">
                  <Td>{p.name}</Td>
                  <Td>{p.crid}</Td>
                  <Td className="text-right">
                    <RowActions
                      onEdit={() => openModal('provider', p)}
                      onDelete={() => requestDelete('provider', p)}
                    />
                  </Td>
                </tr>
              ))}
            </tbody>
          </TableWrapper>

          <MobileCards>
            {mailProviders?.map(p => (
              <Card
                key={p._id}
                title={p.name}
                subtitle={`CRID: ${p.crid}`}
                onEdit={() => openModal('provider', p)}
                onDelete={() => requestDelete('provider', p)}
              />
            ))}
          </MobileCards>
        </TabPanel>

        {/* ===== OWNERS ===== */}
        <TabPanel>
          <HeaderButton label="New Owner" onClick={() => openModal('owner')} />

          <TableWrapper>
            <thead>
              <tr>
                <Th>Name</Th>
                <Th>CRID</Th>
                <Th />
              </tr>
            </thead>
            <tbody>
              {owners?.map(o => (
                <tr key={o._id} className="border-t">
                  <Td>{o.companyName}</Td>
                  <Td>{o.crid}</Td>
                  <Td className="text-right">
                    <RowActions
                      onEdit={() => openModal('owner', o)}
                      onDelete={() => requestDelete('owner', o)}
                    />
                  </Td>
                </tr>
              ))}
            </tbody>
          </TableWrapper>

          <MobileCards>
            {owners?.map(o => (
              <Card
                key={o._id}
                title={o.companyName}
                subtitle={`CRID: ${o.crid}`}
                onEdit={() => openModal('owner', o)}
                onDelete={() => requestDelete('owner', o)}
              />
            ))}
          </MobileCards>
        </TabPanel>

        {/* ===== PRODUCTS ===== */}
        <TabPanel>
          <HeaderButton label="New Product" onClick={() => openModal('product')} />

          <TableWrapper>
            <thead>
              <tr>
                <Th>Name</Th>
                <Th>Size</Th>
                <Th>Weight</Th>
                <Th>Thickness</Th>
                <Th>Special</Th>
                <Th />
              </tr>
            </thead>
            <tbody>
              {products?.map(p => (
                <tr key={p._id} className="border-t">
                  <Td>{p.name}</Td>
                  <Td>{p.width} X {p.length}</Td>
                      <Td>{p.thickness}</Td>
                          <Td>{p.weight} {p.weightUnit}</Td>
                              <Td> {[
  p.hasLooseItems && 'Loose Items',
  p.isNonFlexible && 'Non Flexible',
  p.isPolybagged && 'Poly Bag',
  p.isUnevenThickness && 'Uneven Thickness',
].filter(Boolean).join(', ')} </Td>

                              



                  <Td className="text-right">
                    <RowActions
                      onEdit={() => openModal('product', p)}
                      onDelete={() => requestDelete('product', p)}
                    />
                  </Td>
                </tr>
              ))}
            </tbody>
          </TableWrapper>

        <MobileCards>
  {products?.map(p => (
    <Card
      key={p._id}
      title={p.name}
      subtitle={`${p.width} X ${p.length}`}
      extraInfo={(
        <>
          <p>Weight: {p.weight} {p.weightUnit}</p>
          <p>Thickness: {p.thickness}</p>
          <p>Special: {[
            p.hasLooseItems && 'Loose Items',
            p.isNonFlexible && 'Non Flexible',
            p.isPolybagged && 'Poly Bag',
            p.isUnevenThickness && 'Uneven Thickness',
          ].filter(Boolean).join(', ') || ' None'}</p>
        </>
      )}
      onEdit={() => openModal('product', p)}
      onDelete={() => requestDelete('product', p)}
    />
  ))}
</MobileCards>
        </TabPanel>
             <TabPanel>

  <HeaderButton
    label="New Suppression List (Do Not Mail)"
    onClick={() => openModal('suppress')}
  />

  <TableWrapper>
    <thead>
      <tr>
        <Th>Name</Th>
        <Th>Description</Th>
        <Th>Address's</Th>
        <Th />
      </tr>
    </thead>

    <tbody>
      {suppressionList?.map(s => (
        <tr key={s._id} className="border-t">

          <Td>{s.suppressionListName}</Td>

          <Td>{s.description}</Td>
          <Td>{s.seeds?.length}</Td>

          <Td className="text-right">
            <RowActions
              onEdit={() => openModal('suppress', s)}
              onDelete={() => requestDelete('suppress', s)}
            />
          </Td>

        </tr>
      ))}
    </tbody>
  </TableWrapper>

  <MobileCards>
    {suppressionList?.map(s => (
      <Card
        key={s._id}
        title={s.suppressionListName}
        subtitle={s.description}
        onEdit={() => openModal('seed', s)}
        onDelete={() => requestDelete('seed', s)}
        extraInfo={`${s.seeds?.length} Address's`}
      />
    ))}
  </MobileCards>

</TabPanel>
      <TabPanel>

  <HeaderButton
    label="New Seed List"
    onClick={() => openModal('seed')}
  />

  <TableWrapper>
    <thead>
      <tr>
        <Th>Name</Th>
        <Th>Description</Th>
        <Th>Address's</Th>
        <Th />
      </tr>
    </thead>

    <tbody>
      {seedLists?.map(s => (
        <tr key={s._id} className="border-t">

          <Td>{s.seedListName}</Td>

          <Td>{s.description}</Td>
          <Td>{s.seeds?.length}</Td>

          <Td className="text-right">
            <RowActions
              onEdit={() => openModal('seed', s)}
              onDelete={() => requestDelete('seed', s)}
            />
          </Td>

        </tr>
      ))}
    </tbody>
  </TableWrapper>

  <MobileCards>
    {seedLists?.map(s => (
      <Card
        key={s._id}
        title={s.seedListName}
        subtitle={s.description}
        onEdit={() => openModal('seed', s)}
        onDelete={() => requestDelete('seed', s)}
       extraInfo={`${s.seeds?.length} Address's`}
      />
    ))}
  </MobileCards>

</TabPanel>
      </Tabs>

      {/* ===== MODALS ===== */}
      <MotionModal open={activeModal === 'permit'} onClose={closeModal}>
        <PermitForm normalizedFacilities={normalizedFacilities} permit={selectedItem} onClose={closeModal} setPermits={setPermits} reset={reset} setReset={setReset}/>
      </MotionModal>

      <MotionModal open={activeModal === 'provider'} onClose={closeModal}>
        <MailProvider normalizedFacilities={normalizedFacilities} provider={selectedItem} onClose={closeModal} setMailProviders={setMailProviders} reset={reset} setReset={setReset}/>
      </MotionModal>

      <MotionModal open={activeModal === 'owner'} onClose={closeModal}>
        <MailOwner owner={selectedItem} onClose={closeModal}  setOwners={setOwners} reset={reset} setReset={setReset}/>
      </MotionModal>

      <MotionModal open={activeModal === 'product'} onClose={closeModal}>
        <Products product={selectedItem} onClose={closeModal} setProducts={setProducts} reset={reset} setReset={setReset} />
      </MotionModal>

<MotionModal open={!!confirmDelete} onClose={() => setConfirmDelete(null)}>
  <div className="p-6 max-w-sm">
    <h2 className="text-lg font-semibold mb-3">Confirm Delete</h2>

  <div className="text-sm text-gray-600 mb-6 whitespace-pre-line">
  {getDeleteText()}
</div>

    <div className="flex justify-end gap-3">
      <button
        onClick={() => setConfirmDelete(null)}
        className="px-4 py-2 border rounded"
      >
        Cancel
      </button>

      <button
        onClick={confirmDeleteAction}
        className="px-4 py-2 bg-red-600 text-white rounded"
      >
        Delete
      </button>
    </div>
  </div>
</MotionModal>

<MotionModal open={activeModal === 'suppress'} onClose={closeModal}>
  <Donotmail
    suppressionList={selectedItem}
    onClose={closeModal}
    setSuppressionLists={setSuppressionLists}
    reset={reset}
    setReset={setReset}
  />
</MotionModal>


<MotionModal open={activeModal === 'seed'} onClose={closeModal}>
  <SeedListForm
    seedList={selectedItem}
    onClose={closeModal}
    setSeedLists={setSeedLists}
    reset={reset}
    setReset={setReset}
  />
</MotionModal>
     
    </div>
  );
};

export default Permits;




